import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

export default function AboutHosts() {
  return (
    <section
      id="hosts"
      data-testid="about-hosts-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-primary mb-4 block font-['Outfit']">
            Your Hosts
          </span>
          <h2 className="text-3xl md:text-5xl font-light tracking-tight">
            Meet the Visionaries
          </h2>
        </motion.div>

        {/* Host: Antonio */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start mb-24"
        >
          <div className="md:col-span-4">
            <div className="aspect-square overflow-hidden border border-white/5 bg-secondary/50">
              <img
                src="https://customer-assets.emergentagent.com/job_register-hub-18/artifacts/4xxkyc6l_Copy%20of%20Flyer%20%281%29.png"
                alt="Antonio Jones-Moore"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="md:col-span-8 flex flex-col justify-center">
            <h3 className="text-2xl md:text-3xl font-light tracking-tight mb-2">
              Antonio Jones-Moore
            </h3>
            <p className="text-xs font-['Outfit'] font-semibold tracking-[0.15em] uppercase text-primary mb-6">
              Founder & Lead Esthetician, SKYN CULTURE
            </p>
            <p className="text-base md:text-lg font-['Outfit'] font-light leading-relaxed text-foreground/75">
              Antonio Jones-Moore is the founder and lead esthetician of Skyn Culture Spa in Atlanta,
              where his Progressive Not Aggressive&trade; philosophy guides every client journey. He believes
              that skincare is a lifestyle, not a hobby, and he empowers his clients with education,
              discipline, and consistency so they can achieve lasting results without compromising their
              skin barrier or long-term health.
            </p>
          </div>
        </motion.div>

        {/* Hosts: Crystal & Dr. Nicole */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start"
        >
          <div className="md:col-span-8 flex flex-col justify-center md:order-1 order-2">
            <h3 className="text-2xl md:text-3xl font-light tracking-tight mb-2">
              Crystal Khalil & Dr. Nicole LaBeach
            </h3>
            <p className="text-xs font-['Outfit'] font-semibold tracking-[0.15em] uppercase text-primary mb-6">
              Founders, Sister Diamonds
            </p>
            <p className="text-base md:text-lg font-['Outfit'] font-light leading-relaxed text-foreground/75 mb-5">
              Sister Diamonds, founded by Crystal Khalil and Dr. Nicole LaBeach, creates
              transformational spaces for growth-minded women who are ready to unbind and unleash
              their ultimate potential in business, relationships, and life.
            </p>
            <p className="text-base md:text-lg font-['Outfit'] font-light leading-relaxed text-foreground/75">
              Crystal is known as The Divine Disruptor & Destiny Dealer — a strategist with soul who moves with
              purpose and power. Dr. Nicole, The Soul Surgeon & Sacred Strategist, holds a Ph.D. in psychology
              with 25+ years of experience, transforming lives and holding space for women to remember who they
              were before the world told them who to be.
            </p>
          </div>
          <div className="md:col-span-4 md:order-2 order-1">
            <div className="aspect-[3/4] overflow-hidden border border-white/5">
              <img
                src="https://customer-assets.emergentagent.com/job_volition-membership/artifacts/wdy6rj8w_crystal%20and%20drnicole.png"
                alt="Crystal Khalil and Dr. Nicole LaBeach"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
